module.exports = __webpack_public_path__ + "img/emo_35.a0d331a3.png";